import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import GlobalStyleReset from './components/GlobalStyleReset';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import HeroSlides from './pages/HeroSlides';
import AboutUs from './pages/AboutUs';
import Products from './pages/Products';
import Gallery from './pages/Gallery';
import FAQs from './pages/FAQs';
import ContactRequests from './pages/ContactRequests';
import ServiceRequests from './pages/ServiceRequests';
import Services from './pages/Services';
import Users from './pages/Users';
import Profile from './pages/Profile';
import Blog from './pages/Blog';
import Testimonials from './pages/Testimonials';
import Banners from './pages/Banners';
import CompanyInfo from './pages/CompanyInfo';
import WhyChooseUs from './pages/WhyChooseUs';
import SEOSettings from './pages/SEOSettings';
import ServiceCategories from './pages/ServiceCategories';
import BlogCategories from './pages/BlogCategories';
import './App.css';
import NotFound from './pages/NotFound';

import { ToastProvider } from './contexts/ToastContext';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <GlobalStyleReset />
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hero-slides"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <HeroSlides />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/about-us"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AboutUs />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/why-choose-us"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <WhyChooseUs />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/banners"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Banners />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/products"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Products />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-posts"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Blog />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gallery"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Gallery />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/faqs"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <FAQs />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/testimonials"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Testimonials />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/company-info"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Layout>
                      <CompanyInfo />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/seo-settings"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Layout>
                      <SEOSettings />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/contact-requests"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ContactRequests />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/service-requests"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ServiceRequests />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/services"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Services />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/service-categories"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ServiceCategories />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-categories"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <BlogCategories />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Profile />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/users"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Layout>
                      <Users />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
